export default __webpack_public_path__ + "static/media/Day 1 - 14 Dec 2021 - update 141221.bdc5272d.jpg";